"use client"

import Image from "next/image"
import Box from "@mui/material/Box"

const DEFAULT_SIZES =
  "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"

interface DynamicImageProps {
  src: string
  sizes?: string
  alt?: string
  width?: number
  height?: number
  priority?: boolean
  className?: string
  style?: React.CSSProperties
  fill?: boolean
  sx?: object
  [key: string]: unknown
}

export default function DynamicImage({
  src,
  sizes,
  sx,
  style,
  fill,
  className,
  ...rest
}: DynamicImageProps) {
  if (!src) {
    return null
  }

  const objectFit = (rest.objectFit as React.CSSProperties["objectFit"]) ?? "cover"
  const objectPosition = rest.objectFit ? undefined : "center"

  return (
    <Box
      className={className}
      sx={{
        position: "relative",
        ...sx
      }}
    >
      <Image
        src={src}
        fill={fill}
        {...rest}
        alt={rest.alt || ""}
        sizes={sizes || DEFAULT_SIZES}
        style={{ ...style, objectFit, objectPosition }}
      />
    </Box>
  )
}
